import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalHolderService {

    map:Map<string, any> = new Map();

    constructor() { }

    set(key:string, val:any) {
        this.map.set(key,val);
    }

    get(key) {
        return this.map.get(key);
    }
}
